module.exports = __webpack_public_path__ + "media/images/icon_mypage_arrow_up-e317efd504964d95d8f19e7e8fbee521.png";